import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzK9BlBg } from './pages'

type TIdToPageMapWoofzK9BlBg = Record<PageIdWoofzK9BlBg, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_K9_BL_BG: TIdToPageMapWoofzK9BlBg = {
  [PageIdWoofzK9BlBg.DOG_AGE_K9_BL_BG]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/questions/DogAge').then(
        (m) => ({
          default: m.DogAge,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/questions/DogAge'),
  },
  [PageIdWoofzK9BlBg.DOG_SEX_K9_BL_BG]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/questions/SexQuestion').then(
        (m) => ({
          default: m.SexQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/questions/SexQuestion'),
  },
  [PageIdWoofzK9BlBg.DOG_BREED_K9_BL_BG]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_bl_bg/pages/questions/dog-breed/DogBreedQuestion'
      ).then((m) => ({
        default: m.DogBreedQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_k9_bl_bg/pages/questions/dog-breed/DogBreedQuestion'
      ),
  },
  [PageIdWoofzK9BlBg.DOG_BREED_ID_K9_BL_BG]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_bl_bg/pages/questions/dog-breed/breed-id/BreedPhotoScreenK9'
      ).then((m) => ({
        default: m.BreedPhotoScreenK9,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_k9_bl_bg/pages/questions/dog-breed/breed-id/BreedPhotoScreenK9'
      ),
  },
  [PageIdWoofzK9BlBg.URGE_K9_BL_BG]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/urge/UrgePage').then((m) => ({
        default: m.UrgePage,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_k9_bl_bg/pages/urge/UrgePage'),
  },
  [PageIdWoofzK9BlBg.CHALLENGES_K9_BL_BG]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_bl_bg/pages/questions/GoalsQuestionK9'
      ).then((m) => ({
        default: m.GoalsQuestionK9,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/questions/GoalsQuestionK9'),
  },
  [PageIdWoofzK9BlBg.URGE_1_K9_BL_BG]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/urge/Urge1Page').then((m) => ({
        default: m.Urge1Page,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_k9_bl_bg/pages/urge/Urge1Page'),
  },
  [PageIdWoofzK9BlBg.LEASH_PULLING_K9_BL_BG]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/questions/LeashPulling').then(
        (m) => ({
          default: m.LeashPulling,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/questions/LeashPulling'),
  },
  [PageIdWoofzK9BlBg.URGE_LEASH_K9_BL_BG]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/urge/UrgeLeashPage').then(
        (m) => ({
          default: m.UrgeLeashPage,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/urge/UrgeLeashPage'),
  },
  [PageIdWoofzK9BlBg.DURING_WALK_K9_BL_BG]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_bl_bg/pages/questions/DuringWalkQuestion'
      ).then((m) => ({
        default: m.DuringWalkQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/questions/DuringWalkQuestion'),
  },
  [PageIdWoofzK9BlBg.URGE_NOT_ALONE_K9_BL_BG]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/urge/UrgeNotAlone').then(
        (m) => ({
          default: m.UrgeNotAlonePage,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/urge/UrgeNotAlone'),
  },
  [PageIdWoofzK9BlBg.AGRESSIVE_BEHAVIOR_K9_BL_BG]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_bl_bg/pages/questions/AgressiveBehavior'
      ).then((m) => ({
        default: m.AgressiveBehavior,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/questions/AgressiveBehavior'),
  },
  [PageIdWoofzK9BlBg.TRIGGERS_K9_BL_BG]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_bl_bg/pages/questions/TriggersQuestion'
      ).then((m) => ({
        default: m.TriggersQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/questions/TriggersQuestion'),
  },
  [PageIdWoofzK9BlBg.URGE_2_K9_BL_BG]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/urge/UrgePageVariant2').then(
        (m) => ({
          default: m.UrgePageVariant2,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/urge/UrgePageVariant2'),
  },
  [PageIdWoofzK9BlBg.BEHAVIOR_ISSUES_K9_BL_BG]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_bl_bg/pages/questions/BehaviorIssues'
      ).then((m) => ({
        default: m.BehaviorIssues,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/questions/BehaviorIssues'),
  },
  [PageIdWoofzK9BlBg.DOG_ACT_K9_BL_BG]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_bl_bg/pages/questions/DogActQuestion'
      ).then((m) => ({
        default: m.DogActQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/questions/DogActQuestion'),
  },
  [PageIdWoofzK9BlBg.DOG_OFF_AT_HOME_K9_BL_BG]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/questions/DogOffAtHome').then(
        (m) => ({
          default: m.DogOffAtHome,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/questions/DogOffAtHome'),
  },
  [PageIdWoofzK9BlBg.REWARDS_K9_BL_BG]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_bl_bg/pages/questions/RewardsQuestion'
      ).then((m) => ({
        default: m.RewardsQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/questions/RewardsQuestion'),
  },
  [PageIdWoofzK9BlBg.IGNORE_COMMANDS_K9_BL_BG]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_bl_bg/pages/questions/DogIgnoreQuestion'
      ).then((m) => ({
        default: m.DogIgnoreQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/questions/DogIgnoreQuestion'),
  },
  [PageIdWoofzK9BlBg.COMMANDS_61_K9_BL_BG]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_bl_bg/pages/questions/Commands61Question'
      ).then((m) => ({
        default: m.Commands61Question,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/questions/Commands61Question'),
  },
  [PageIdWoofzK9BlBg.COMMANDS_62_K9_BL_BG]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_bl_bg/pages/questions/Commands62Question'
      ).then((m) => ({
        default: m.Commands62Question,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/questions/Commands62Question'),
  },
  [PageIdWoofzK9BlBg.COMMANDS_63_K9_BL_BG]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_bl_bg/pages/questions/Commands63Question'
      ).then((m) => ({
        default: m.Commands63Question,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/questions/Commands63Question'),
  },
  [PageIdWoofzK9BlBg.URGE_3_K9_BL_BG]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/urge/UrgeProgram').then(
        (m) => ({
          default: m.UrgeProgram,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/urge/UrgeProgram'),
  },
  [PageIdWoofzK9BlBg.PREPARE_SCREEN_K9_BL_BG]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/urge/UrgePrepareScreen').then(
        (m) => ({
          default: m.UrgePrepareScreen,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/urge/UrgePrepareScreen'),
  },
  [PageIdWoofzK9BlBg.DOG_PROFILE_K9_BL_BG]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/dog-profile/DogProfile').then(
        (m) => ({
          default: m.DogProfile,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/dog-profile/DogProfile'),
  },
  [PageIdWoofzK9BlBg.URGE_REVIEWED_K9_BL_BG]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/urge/UrgeReviewed').then(
        (m) => ({
          default: m.UrgeReviewedPage,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/urge/UrgeReviewed'),
  },
  [PageIdWoofzK9BlBg.PREPARE_FLOW_K9_BL_BG]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_bl_bg/pages/prepare-flow/PrepareFlow'
      ).then((m) => ({
        default: m.PrepareFlow,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/prepare-flow/PrepareFlow'),
  },
  [PageIdWoofzK9BlBg.EMAIL_K9_BL_BG]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/email/Email').then((m) => ({
        default: m.Email,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_k9_bl_bg/pages/email/Email'),
  },
  [PageIdWoofzK9BlBg.NEWSLETTER_URGE_K9_BL_BG]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/email/NewsletterUrge').then(
        (m) => ({
          default: m.NewsletterUrge,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/email/NewsletterUrge'),
  },
  [PageIdWoofzK9BlBg.SCRATCH_SCREEN_K9_BL_BG]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_bl_bg/pages/last-chance-offer/LastChanceOfferScratch'
      ).then((m) => ({
        default: m.LastChanceOfferScratch,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_k9_bl_bg/pages/last-chance-offer/LastChanceOfferScratch'
      ),
  },
  [PageIdWoofzK9BlBg.SUBSCRIPTIONS_K9_BL_BG]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_bl_bg/pages/subscriptions/Subscriptions'
      ).then((m) => ({
        default: m.Subscriptions,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/subscriptions/Subscriptions'),
  },
  [PageIdWoofzK9BlBg.CHAT_UPSELL_K9_BL_BG]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_bl_bg/pages/upsell/ChatUpsellNewFlow'
      ).then((m) => ({
        default: m.ChatUpsellNewFlow,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/upsell/ChatUpsellNewFlow'),
  },
  [PageIdWoofzK9BlBg.UPSELL_K9_BL_BG]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/upsell/Upsell').then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_k9_bl_bg/pages/upsell/Upsell'),
  },
  [PageIdWoofzK9BlBg.UPSELL_FEEDING_GUIDE_K9_BL_BG]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_bl_bg/pages/upsell/FeedingGuideUpsell'
      ).then((m) => ({
        default: m.FeedingGuideUpsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/upsell/FeedingGuideUpsell'),
  },
  [PageIdWoofzK9BlBg.UPSELL_EMOTIONAL_SUPPORT_K9_BL_BG]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_bl_bg/pages/upsell/EmotionalSupportUpsell'
      ).then((m) => ({
        default: m.EmotionalSupportUpsell,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_k9_bl_bg/pages/upsell/EmotionalSupportUpsell'
      ),
  },
  [PageIdWoofzK9BlBg.DOWNLOAD_K9_BL_BG]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_k9_bl_bg/pages/download-app/DownloadApp'
      ).then((m) => ({
        default: m.DownloadApp,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl_bg/pages/download-app/DownloadApp'),
  },
  [PageIdWoofzK9BlBg.ACCOUNT_K9_BL_BG]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_k9_bl_bg/modules/account/AccountK9Bl').then(
        (m) => ({
          default: m.AccountK9Bl,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_k9_bl_bg/modules/account/AccountK9Bl'),
  },
}
